export const Step = {
  MODULE: 1,
  CONTENT: 2,
  PUBLISH: 3
};

export const Status = {
  CHECK: 'CHECK',
  FILLED: 'FILLED',
  EMPTY: 'EMPTY'
};

const CheckListIndex = {
  FIRST: 0,
  SECOND: 1,
  THIRD: 2
};

export const StepStatus = {
  [Step.MODULE]: {
    [CheckListIndex.FIRST]: Status.FILLED,
    [CheckListIndex.SECOND]: Status.EMPTY,
    [CheckListIndex.THIRD]: Status.EMPTY
  },
  [Step.CONTENT]: {
    [CheckListIndex.FIRST]: Status.CHECK,
    [CheckListIndex.SECOND]: Status.FILLED,
    [CheckListIndex.THIRD]: Status.EMPTY
  },
  [Step.PUBLISH]: {
    [CheckListIndex.FIRST]: Status.CHECK,
    [CheckListIndex.SECOND]: Status.CHECK,
    [CheckListIndex.THIRD]: Status.FILLED
  }
};

export const ChecklistHeadingLabel = {
  [Step.MODULE]: 'online_event.onboarding.start_adding_modules',
  [Step.CONTENT]: 'onboarding.upload_content_new',
  [Step.PUBLISH]: 'onboarding.just_publish_new'
};

export const ChecklistSettings = [
  {
    stepNumber: Step.MODULE,
    todoLabel: 'onboarding.steps.module.add_v2',
    doneLabel: 'onboarding.steps.module.added'
  },
  {
    stepNumber: Step.CONTENT,
    todoLabel: 'onboarding.steps.content.add',
    doneLabel: 'onboarding.steps.content.added'
  },
  {
    stepNumber: Step.PUBLISH,
    todoLabel: 'onboarding.steps.publish'
  }
];

export const getChecklistSettings = (isOnlineEvent) => {
  if (isOnlineEvent) {
    return [
      {
        stepNumber: Step.MODULE,
        todoLabel: 'onboarding.steps.module.add_v2',
        doneLabel: 'onboarding.steps.module.add_v2'
      },
      {
        stepNumber: Step.CONTENT,
        todoLabel: 'onboarding.online_event.steps.content.add',
        doneLabel: 'onboarding.online_event.steps.content.add'
      },
      {
        stepNumber: Step.PUBLISH,
        todoLabel: 'onboarding.steps.publish_new'
      }
    ];
  }
  return [
    {
      stepNumber: Step.MODULE,
      todoLabel: 'onboarding.steps.module.add_v2',
      doneLabel: 'onboarding.steps.module.added'
    },
    {
      stepNumber: Step.CONTENT,
      todoLabel: 'onboarding.steps.content.add_new',
      doneLabel: 'onboarding.steps.content.added'
    },
    {
      stepNumber: Step.PUBLISH,
      todoLabel: 'onboarding.steps.publish_new'
    }
  ];
};

export const getTipStepLabelOnlineEvent = (step) => {
  const labels = new Map();

  labels.set(Step.MODULE, 'onboarding.online_event.welcome_content_new');

  return labels.get(step);
};
